import { APIInstance } from '@/utils/functions/instance'

export const deleteDocument = async (id: number): Promise<{}> => {
  const response = await APIInstance.delete(`mrf/documents/${id}/`)
  return response
}
